import useSetupTimeline from './useSetupTimeline';
import useScrollTrigger from './useScrollTrigger';
import type { OptionsType } from './useScrollTrigger';
import type { ScrollCarouselRefs } from '../util/animation/scroll-carousel/scroll-carousel.types';
import { setupScrollCarousel } from '../util/animation/scroll-carousel/scroll-carousel';

export const useScrollCarousel = (
  refs: ScrollCarouselRefs,
  options: OptionsType,
  vars?: ScrollTrigger.Vars,
): void => {
  const { trigger } = options;

  useScrollTrigger({
    pin: trigger,
    animation: useSetupTimeline(setupScrollCarousel, refs),
    vars: {
      scrub: true,
      start: 'top top',
      pinType: 'transform',
      anticipatePin: 1,
      onUpdate: refs?.onUpdate,
      end: () =>
        `+=${
          (refs?.carouselRef?.current?.scrollWidth || 0) -
          (refs?.carouselRef?.current?.offsetWidth || 0)
        }`,
      ...vars,
    },
    ...options,
    trigger,
  });
};
